import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { LETTER_SPACING, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  display: flex;
  gap: ${OFFSET.S};
`;

export const Button = styled.button`
  ${typography({ spacing: LETTER_SPACING.M })};
  background-color: ${({ active }: { active: boolean }) => (active ? COLORS.GALLERY : 'transparent')};
  border-radius: 24px;
  height: 26px;
  padding: 3px 12px;
`;
